export default "__VITE_ASSET__Cvr$GO_0__"